import styled, { css } from 'styled-components';

import { setSvgColor } from 'styles/mixins';

export const MainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.padding.default};
`;

export const DropzoneContainer = styled.div<{ error?: string }>`
  width: 100%;
  height: 184px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  overflow: hidden;
  cursor: pointer;
  position: relative;

  .image-preview-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      object-fit: cover;
    }
  }

  .overlay-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.3);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .camera-icon {
      width: 40px;
      height: 40px;
    }

    .labels-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
  }

  ${({ theme, error }) => css`
    gap: ${theme.padding.small};
    border-radius: ${theme.borderRadius.big};
    background-color: ${theme.colors.darkGrey.main};
    border: 2px dashed;
    border-color: ${error
      ? theme.colors.red.main
      : theme.colors.lightGrey.hover};

    .overlay-container {
      ${setSvgColor(theme.colors.white.main)};

      .labels-container {
        color: ${theme.colors.white.main};
        padding: 0 ${theme.padding.biggest};
      }
    }

    &:hover {
      background-color: ${theme.colors.darkGrey.hover};
    }
  `}
`;
